import { useRef, useState } from "react"
import { BiCheck } from "react-icons/bi"
import { FiCopy } from "react-icons/fi"
import { useAppSelector } from "../../store/hooks"

interface InputCopyProps {
  text: string,
  value: string,
  es: boolean,
  campaign:string,
  template: string,
}
const TemplateCopy = ({ text, value, es, campaign, template}: InputCopyProps) => {
  const { brand} =useAppSelector(state=>state.campaign.detail)
  const [copied, setCopied] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  const template_link = template.replace('{link}', value)
 /*  const Copyurl = () => {
    let content = ref.current?.textContent || ''
    navigator.clipboard.writeText(content)
      .then(() => {
        setCopied(true)
        setTimeout(function () { setCopied(false) }, 1000);
      })
      .catch((err) => {
        console.log('Something went wrong', err);
      })
  } */

  const CopySelect = () => {
    var container = document.createElement('div')
    container.innerHTML = ref.current?.innerHTML || ''
    document.body.appendChild(container)
    window.getSelection()?.removeAllRanges();
    let range = document.createRange();
    range.selectNode(container);
    window.getSelection()?.addRange(range);
    document.execCommand('copy');
    window.getSelection()?.removeAllRanges();
    document.body.removeChild(container)
    setCopied(true)
    setTimeout(function () { setCopied(false) }, 1000);
  }

  const Templateauto = ()=>{
    return (
      <>
        <div className="link-templates__email-text">

          {
            es ? `Hola,<name>`
              : `Hello <name>`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `¿Haz estado buscando un seguro de automóvil accesible? ¿Cansado de buscar? En ${brand === 'BAJA' ? `Baja Auto Insurance` : `Freeway Insurance`}  comparamos varias compañías para asegurarnos de que obtengas la mejor tarifa para ti. Podemos conseguirte las mejores tarifas en tu seguro de auto sin importar tu historial de manejo. ¡No es broma!`
              : `Have you been searching for affordable auto insurance?  Are you tired of researching multiple websites?   At ${brand === 'BAJA' ? `Baja Auto Insurance` : `Freeway Insurance`}, we compare multiple carriers to make sure you get the best rate for you.  We can get you the best rates on your auto insurance no matter what your driving record.  That’s no joke!.`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `Hoy podemos ahorrarte hasta un ${brand === 'BAJA'?`25%`: `30%`} en tu seguro de auto. Obtener una cotización es fácil, simplemente haz clic en el botón de abajo para comenzar.`
              : `I can save you up to ${brand === 'BAJA' ? `25%` : `30%`} on your car insurance today. Getting a quote is easy;  just click on the button below to get started.`
          }
        </div>
        <a href={es ? `${value}?utm_medium=email_template_Spa` : `${value}?utm_medium=email_template_Eng`} className="link-templates__email-button">
          {
            es ? `Cotiza y Compara en línea`
              : `Quote & Compare Online`
          }
        </a>
        <div className="link-templates__email-text">
          {
            es ? `Permítenos ayudarte a ahorrar tiempo y dinero con una cotización instantánea hecha a la medida de tu presupuesto. No dudes en llamarnos si tienes preguntas.`
              : `Let me help you save time and money with an instant quote made to fit your budget.  Don’t hesitate to give me a call if you have questions.`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `Saludos,`
              : `Best,`
          }

        </div>
        <div className="link-templates__email-text">
          {
            es ? `<Nombre del Agente>`
              : `<Agent Name>`
          }
        </div>
      </>
    )
  }

  const Templatelife = ()=>{
    return(
      <>
        <div className="link-templates__email-text">

          {
            es ? `Hola,<name>`
              : `HI <name>`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `Fue un placer conocerlo y aprender más sobre sus necesidades de seguro. Estoy seguro de que podemos ayudarlo a ahorrar y obtener la cobertura adecuada para usted.`
              : `It was a pleasure meeting you and learning more about your insurance needs. I am confident we can help you save and get the right coverage for you.`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `Aquí hay un enlace a la información que solicitó sobre el seguro de vida. Puede obtener una cotización en línea, comparar múltiples proveedores y, en algunos casos, ni siquiera necesita realizar un examen físico.`
              : `Here is a link to the information you requested about life insurance. You can get an online quote, compare multiple carriers, and in some cases, you don't even need to do a physical exam.`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `No hay mejor manera de demostrarle a sus seres queridos cuánto le importa. Simplemente haga clic a continuación para obtener una cotización gratuita en línea en minutos.`
              : `There’s no better way to show your loved ones how much you care. Just click below to get a free quote online in minutes.`
          }
        </div>
        <a href={es ? `${value}?utm_medium=email_template_Spa` : `${value}?utm_medium=email_template_Eng`} className="link-templates__email-button">
          {
            es ? `Cotiza y Compara en línea`
              : `Quote & Compare Online`
          }
        </a>
        <div className="link-templates__email-text">
          {
            es ? `Saludos,`
              : `Regars.`
          }

        </div>
        <div className="link-templates__email-text">
          {
            es ? `<Nombre del Agente>`
              : `<Agent Name>`
          }
        </div>
        <div className="link-templates__email-text">
          {
            es ? `Firma`
              : `Signature`
          }
        </div>
      </>
    )
  }

  return (
  <div className="link-templates__container">
    <div className="link-templates__header">
      <span className="link-templates__title">{text}</span>
      {
        copied?
          <div className="link-templates__box-copied">
            Copied <BiCheck />
          </div>
        :
          <div className="link-templates__box-copy" onClick={CopySelect}>
            <FiCopy />Copy
          </div>
      }
    </div>
    <div className="link-templates__content" ref={ref}>
      <div className="link-templates__email-box">

       {/*  {
          campaign === 'life' && <Templatelife/>
        }

        {
          campaign === 'auto' && <Templateauto/>
        } */}
          <div dangerouslySetInnerHTML={{ __html: template_link }} />
      </div>
    </div>
  </div>
  )
}

export default TemplateCopy